import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND;

const request = (url = '', method = 'GET', data, headers={}) =>
  new Promise((resolve, reject) => {
    axios({
      url,
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      data
    })
      .then((response) => {
        return resolve(response);
      })
      .catch((error) => {
        return reject(error);
      });
  });

export default request;



// WEBPACK FOOTER //
// ./src/helpers/request.js